exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-main[data-v-3784cb41] {\n  /* background-color: rgb(241, 241, 241); */\n}\n.column-wrap[data-v-3784cb41] {\n  background-color: white;\n  border-bottom: 1px solid #a0a0a0;\n  text-align: left;\n  padding: 10px 0;\n  margin: 0 20px;\n}\n.column-wrap p[data-v-3784cb41]:first-child {\n  color: lightgray;\n}\n.column-wrap .content[data-v-3784cb41] {\n  margin-top: 20px;\n}\n.column-wrap input[data-v-3784cb41] {\n  font-size: large;\n}\n", ""]);

// exports
